// Drafted by exact opencode-go/glm-5.3 and edited with Matthew's, Hermes's
// and unslop writing rules. No reply-time or medical claims.
// Role copy: verified author session ses_f0be1254dffeQx8ZJL6LtrALAC.
export const careCopy = {
  nav: 'Support',
  pageTitle: 'Your support page',
  signInPrompt: 'Sign in to continue.',
  emptySpace: 'Nothing here yet.',
  tasksTitle: 'Tasks',
  practitionerRole: "Practitioner view. You assign tasks and read your client's task log.",
  clientRole: 'Client view. You write notes in your task log and mark tasks done.',
  practitionerTasks: 'Assigned tasks',
  clientTasks: 'My task log',
  practitionerHelp: 'Assign a task here. Client logs appear below.',
  clientHelp: 'Choose a task and add a note about practice.',
  messagesTitle: 'Messages',
  emptyTasks: 'No tasks yet.',
  emptyMessages: 'No messages yet.',
  assignTitle: 'Assign a task',
  taskTitleLabel: 'Task title',
  taskInstructionsLabel: 'Instructions',
  assignButton: 'Assign',
  noteLabel: 'Task log note',
  saveNote: 'Save to task log',
  completeTask: 'Mark done',
  completionLabel: 'Completed',
  messageLabel: 'Message',
  sendMessage: 'Send',
  urgentNotice: 'This inbox is not for urgent help. If you need urgent help now, please contact your local emergency services.',
  loading: 'Loading...',
  error: 'Something went wrong. Please try again.',
}
